import { Component, Input, OnInit } from '@angular/core';
import { FinalSolutionStateEnum } from '@app/ps/enums/final-solution-state.enum';

@Component({
  templateUrl: './occupations-approve-change-final-solution-type.component.html',
  styleUrls: ['./occupations-approve-change-final-solution-type.component.scss']
})
export class OccupationsApproveChangeFinalSolutionTypeComponent implements OnInit {
  @Input() data: any;
  @Input() notifyParent: Function;

  readonly FinalSolutionStateEnum = FinalSolutionStateEnum;

  inputData: any = {};

  readonly actions = [
    { id: FinalSolutionStateEnum.APPROVED, name: 'Schválit' },
    { id: FinalSolutionStateEnum.REJECTED, name: 'Zamítnout' },
  ];

  ngOnInit() {
    this.inputData = this.data.details || {};
    this.updated();
  }

  updated() {
    this.notifyParent(() => !!this.inputData.action && (this.inputData.action !== FinalSolutionStateEnum.REJECTED || !!(this.inputData.note && this.inputData.note.trim())), this.inputData);
  }
}
